type ErrorPayload = {
  translationKey: string
  errorMessage: string
  errorCode: string
  statusCode?: number
}

class HeapsError extends Error {
  public translationKey: string
  public errorMessage: string
  public errorCode: string
  public statusCode?: number

  constructor({
    translationKey,
    errorMessage,
    errorCode,
    statusCode,
  }: ErrorPayload) {
    super(errorMessage)
    this.name = this.constructor.name
    this.translationKey = translationKey
    this.errorMessage = errorMessage
    this.errorCode = errorCode.toLowerCase()
    this.statusCode = statusCode

    // https://medium.com/@Nelsonalfonso/understanding-custom-errors-in-typescript-a-complete-guide-f47a1df9354c
    Object.setPrototypeOf(this, HeapsError.prototype)

    // Only works in V8 engine (Firefox will trow an error)
    if ("captureStackTrace" in Error) {
      Error.captureStackTrace(this, this.constructor)
    }
  }
}
export default HeapsError
